/**
 * AGROMX Frontend - Tractores List View
 * Vista de listado de tractores
 */

import tractorService from '../services/tractor.service.js';
import modeloService from '../services/modelo.service.js';
import almacenService from '../services/almacen.service.js';
import toast from '../utils/toast.js';
import modal from '../utils/modal.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import { normalizers, attachNormalizer } from '../utils/inputNormalizer.js';

let currentPage = 1;
let currentFilters = {};

export default {
  async render() {
    return `
      <div>
        <div class="card">
          <div class="card-header">
            <h2 class="card-title">Gestión de Tractores</h2>
            <!-- El alta del tractor vive en Recepciones Visuales: ahi es donde la unidad
                 entra al sistema. Tener dos puertas de alta deja unidades sin recepcion y
                 despues nadie sabe por donde entraron. El formulario (showCreateModal) se
                 conserva por si hiciera falta volver. -->
          </div>

          <!-- Filtros -->
          <div style="display: flex; gap: var(--spacing-md); margin-bottom: var(--spacing-lg); flex-wrap: wrap;">
            <div class="form-group" style="margin: 0; flex: 1; min-width: 200px;">
              <input 
                type="text" 
                id="searchInput" 
                class="form-input" 
                placeholder="Buscar por número de serie o modelo..."
              />
            </div>
            <div class="form-group" style="margin: 0; width: 150px;">
              <select id="estadoFilter" class="form-select">
                <option value="">Todos los estados</option>
                <option value="en_almacen">En Almacén</option>
                <option value="en_produccion">En Producción</option>
                <option value="liberado">Liberado</option>
                <option value="entregado">Entregado</option>
                <option value="en_servicio">En Servicio</option>
              </select>
            </div>
            <div class="form-group" style="margin: 0; width: 150px;">
              <select id="marcaFilter" class="form-select">
                <option value="">Todas las marcas</option>
                <option value="LOVOL">LOVOL</option>
                <option value="MAQMUT">MAQMUT</option>
                <option value="AOSHENG">AOSHENG</option>
                <option value="BEE MACH">BEE MACH</option>
              </select>
            </div>
            <div class="form-group" style="margin: 0; width: 180px;">
              <select id="almacenFilter" class="form-select">
                <option value="">Todos los almacenes</option>
              </select>
            </div>
            <button class="btn btn-secondary" onclick="window.tractoresView.resetFilters()">
              Limpiar Filtros
            </button>
          </div>

          <!-- Tabla -->
          <div id="tractoresTable">
            <div style="text-align: center; padding: var(--spacing-xl);">
              <div class="loading-spinner" style="margin: 0 auto;"></div>
              <p>Cargando tractores...</p>
            </div>
          </div>

          <!-- Paginación -->
          <div id="pagination"></div>
        </div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('tractores')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    // Exponer métodos globalmente
    window.tractoresView = this;

    // Cargar almacenes para filtro y modales
    await this.cargarAlmacenes();

    // Cargar tractores
    await this.loadTractores();

    // Configurar filtros
    document.getElementById('searchInput').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        currentFilters.search = e.target.value;
        currentPage = 1;
        this.loadTractores();
      }, 500);
    });

    document.getElementById('estadoFilter').addEventListener('change', (e) => {
      currentFilters.estado = e.target.value;
      currentPage = 1;
      this.loadTractores();
    });

    document.getElementById('marcaFilter').addEventListener('change', (e) => {
      currentFilters.marca = e.target.value;
      currentPage = 1;
      this.loadTractores();
    });

    document.getElementById('almacenFilter').addEventListener('change', (e) => {
      currentFilters.almacen_id = e.target.value;
      currentPage = 1;
      this.loadTractores();
    });
  },

  async cargarAlmacenes() {
    try {
      const response = await almacenService.listarActivos();
      this.almacenes = response.data.almacenes || [];
      const filtro = document.getElementById('almacenFilter');
      if (filtro) {
        filtro.innerHTML = `
          <option value="">Todos los almacenes</option>
          ${this.almacenes.map(a => `
            <option value="${a.id}">${a.codigo} - ${a.nombre}</option>
          `).join('')}
        `;
      }
    } catch (error) {
      console.error('Error al cargar almacenes:', error);
      this.almacenes = [];
    }
  },

  async loadTractores() {
    const tableContainer = document.getElementById('tractoresTable');

    try {
      const response = await tractorService.list({
        page: currentPage,
        limit: 10,
        ...currentFilters
      });

      const tractores = response.data;
      const pagination = response.pagination;

      if (tractores.length === 0) {
        tableContainer.innerHTML = `
          <div style="text-align: center; padding: var(--spacing-xl); color: var(--gray-500);">
            <p>No se encontraron tractores</p>
          </div>
        `;
        document.getElementById('pagination').innerHTML = '';
        return;
      }

      // Renderizar tabla
      tableContainer.innerHTML = `
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>Número de Serie</th>
              <th class="tbl-hide-mobile">Modelo</th>
              <th class="tbl-hide-mobile">Marca</th>
              <th class="tbl-hide-mobile">Almacén</th>
              <th class="tbl-hide-mobile">Horas Motor</th>
              <th class="tbl-hide-mobile">Estado</th>
              <th class="tbl-hide-mobile">Acciones</th>
            </tr>
          </thead>
          <tbody>
            ${tractores.map(tractor => {
              const ns = tractor.num_serie;
              const badgeClass = tractorService.getEstadoBadgeClass(tractor.estado);
              const estadoText = tractorService.formatEstado(tractor.estado);
              const almacenTxt = tractor.almacen_nombre || 'Sin asignar';
              const tieneRecepciones = Number(tractor.recepciones_count) > 0;
              const ocFolio = tractor.oc_folio || '';
              const bloqueado = tieneRecepciones || !!ocFolio;
              const deleteBtnStyle = bloqueado ? ' style="opacity: 0.5; cursor: not-allowed;"' : '';
              const deleteBtn = permisos.canDelete('tractores')
                ? `<button class="btn btn-sm btn-danger"${deleteBtnStyle} onclick="window.tractoresView.deleteTractor('${ns}', ${tieneRecepciones}, '${ocFolio}')">Eliminar</button>`
                : '';
              return `
              <tr>
                <td>
                  <button class="tbl-expand-btn" onclick="window.tractoresView.toggleRow('${ns}')">&#9654;</button>
                </td>
                <td><strong>${ns}</strong></td>
                <td class="tbl-hide-mobile">${tractor.modelo}</td>
                <td class="tbl-hide-mobile">${tractor.marca}</td>
                <td class="tbl-hide-mobile">${almacenTxt}</td>
                <td class="tbl-hide-mobile">${Number(tractor.horas_motor) || 0} hrs</td>
                <td class="tbl-hide-mobile">
                  <span class="badge ${badgeClass}">${estadoText}</span>
                </td>
                <td class="tbl-hide-mobile">
                  ${permisos.canView('tractores') ? `<button class="btn btn-sm btn-secondary" onclick="window.tractoresView.viewTractor('${ns}')">Ver</button>` : ''}
                  ${permisos.canView('tractores') ? `<button class="btn btn-sm btn-secondary" title="Su historia: cuándo entró y qué le ha pasado" onclick="window.tractoresView.verHistoria('${ns}')">Historia</button>` : ''}
                  ${permisos.canEdit('tractores') ? `<button class="btn btn-sm btn-primary" onclick="window.tractoresView.editTractor('${ns}')">Editar</button>` : ''}
                  ${deleteBtn}
                </td>
              </tr>
              <tr class="tbl-detail-row" id="detail-${ns}">
                <td colspan="8" class="tbl-detail-cell">
                  <dl class="tbl-detail-grid">
                    <dt>Modelo</dt><dd>${tractor.modelo}</dd>
                    <dt>Marca</dt><dd>${tractor.marca}</dd>
                    <dt>Almacén</dt><dd>${almacenTxt}</dd>
                    <dt>Horas Motor</dt><dd>${Number(tractor.horas_motor) || 0} hrs</dd>
                    <dt>Estado</dt><dd><span class="badge ${badgeClass}">${estadoText}</span></dd>
                  </dl>
                  <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
                    ${permisos.canView('tractores') ? `<button class="btn btn-sm btn-secondary" onclick="window.tractoresView.viewTractor('${ns}')">Ver</button>` : ''}
                  ${permisos.canView('tractores') ? `<button class="btn btn-sm btn-secondary" title="Su historia: cuándo entró y qué le ha pasado" onclick="window.tractoresView.verHistoria('${ns}')">Historia</button>` : ''}
                    ${permisos.canEdit('tractores') ? `<button class="btn btn-sm btn-primary" onclick="window.tractoresView.editTractor('${ns}')">Editar</button>` : ''}
                    ${deleteBtn}
                  </div>
                </td>
              </tr>
            `}).join('')}
          </tbody>
        </table>
      `;

      // Renderizar paginación
      this.renderPagination(pagination);
    } catch (error) {
      tableContainer.innerHTML = `
        <div style="text-align: center; padding: var(--spacing-xl); color: var(--danger);">
          <p>Error al cargar tractores: ${error.message}</p>
        </div>
      `;
      toast.error('Error al cargar tractores');
    }
  },

  renderPagination(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div class="pagination">';

    // Botón anterior
    html += `
      <button 
        class="pagination-btn" 
        ${page === 1 ? 'disabled' : ''}
        onclick="window.tractoresView.goToPage(${page - 1})"
      >
        ← Anterior
      </button>
    `;

    // Páginas
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button 
            class="pagination-btn ${i === page ? 'active' : ''}"
            onclick="window.tractoresView.goToPage(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span style="padding: 0 0.5rem;">...</span>';
      }
    }

    // Botón siguiente
    html += `
      <button 
        class="pagination-btn" 
        ${page === totalPages ? 'disabled' : ''}
        onclick="window.tractoresView.goToPage(${page + 1})"
      >
        Siguiente →
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  goToPage(page) {
    currentPage = page;
    this.loadTractores();
  },

  resetFilters() {
    currentFilters = {};
    currentPage = 1;
    document.getElementById('searchInput').value = '';
    document.getElementById('estadoFilter').value = '';
    document.getElementById('marcaFilter').value = '';
    document.getElementById('almacenFilter').value = '';
    this.loadTractores();
  },

  // La bitácora ya guardaba todo esto; sólo faltaba una puerta para verlo.
  verHistoria(numSerie) {
    router.navigate(`/tractores/${encodeURIComponent(numSerie)}/historia`);
  },

  async showCreateModal() {
    try {
      // Cargar marcas
      const marcasResponse = await modeloService.obtenerMarcas();
      const marcas = marcasResponse.data.marcas || [];

      const formHtml = `
        <div class="form-group">
          <label class="form-label">Número de Serie *</label>
          <input type="text" name="num_serie" class="form-input" required />
          <small style="color: var(--text-muted); font-size: 0.85rem;">
            Número de serie único del tractor
          </small>
        </div>

        <div class="form-group">
          <label class="form-label">Marca *</label>
          <select name="marca" id="marca-create-select" class="form-select" required>
            <option value="">Seleccionar marca...</option>
            ${marcas.map(marca => `<option value="${marca}">${marca}</option>`).join('')}
          </select>
          <small style="color: var(--text-muted); font-size: 0.85rem;">
            Primero seleccione la marca
          </small>
        </div>

        <div class="form-group">
          <label class="form-label">Modelo *</label>
          <select name="modelo" id="modelo-create-select" class="form-select" required disabled>
            <option value="">Seleccione primero una marca...</option>
          </select>
          <small style="color: var(--text-muted); font-size: 0.85rem;">
            Los modelos se filtran según la marca
          </small>
        </div>

        <div class="form-group">
          <label class="form-label">Serie del Motor *</label>
          <input type="text" name="serie_motor" class="form-input" required />
        </div>

        <div class="form-group">
          <label class="form-label">Almacén *</label>
          <select name="almacen_id" class="form-select" required>
            <option value="">Seleccionar almacén...</option>
            ${(this.almacenes || []).map(a => `
              <option value="${a.id}">${a.codigo} - ${a.nombre}${a.ubicacion ? ` (${a.ubicacion})` : ''}</option>
            `).join('')}
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Horas del Motor</label>
          <input type="number" name="horas_motor" class="form-input" value="0" min="0" step="0.01" />
        </div>

        <div class="form-group">
          <label style="display: flex; align-items: center; gap: 0.5rem;">
            <input type="checkbox" name="tiene_certificacion_ocima" />
            <span>Tiene Certificación OCIMA</span>
          </label>
        </div>
      `;

      modal.form('Nuevo Tractor', formHtml, async (data) => {
        try {
          if (data.almacen_id) data.almacen_id = parseInt(data.almacen_id, 10);
          data.horas_motor = data.horas_motor === '' || data.horas_motor == null ? 0 : parseFloat(data.horas_motor);
          await tractorService.create(data);
          toast.success('Tractor creado exitosamente');
          modal.close();
          this.loadTractores();
        } catch (error) {
          if (error.code === 'TRACTOR_ELIMINADO_EXISTENTE') {
            modal.confirm(
              'Restaurar tractor',
              `Este número de serie <strong>${data.num_serie}</strong> pertenece a un tractor eliminado. ¿Restaurarlo con los datos que acabas de capturar?`,
              async () => {
                try {
                  await tractorService.reactivar(data.num_serie);
                  const { num_serie, ...updateData } = data;
                  await tractorService.update(num_serie, updateData);
                  toast.success('Tractor restaurado exitosamente');
                  this.loadTractores();
                } catch (err) {
                  toast.error(err.message || 'Error al restaurar tractor');
                }
              }
            );
            return;
          }
          toast.error(error.message || 'Error al crear tractor');
        }
      });

      // Configurar cascada Marca → Modelo después de que el modal se renderice
      setTimeout(() => {
        this.setupCascadaCreate();
        // Normalizar inputs: NS y serie de motor → alfanum + uppercase (sin espacios)
        const nsInput = document.querySelector('input[name="num_serie"]');
        const motorInput = document.querySelector('input[name="serie_motor"]');
        if (nsInput) attachNormalizer(nsInput, normalizers.alfanumUpper);
        if (motorInput) attachNormalizer(motorInput, normalizers.alfanumUpper);
      }, 100);

    } catch (error) {
      console.error('Error al cargar marcas:', error);
      toast.error('No se pudieron cargar las marcas');
    }
  },

  setupCascadaCreate() {
    const marcaSelect = document.getElementById('marca-create-select');
    const modeloSelect = document.getElementById('modelo-create-select');

    if (!marcaSelect || !modeloSelect) return;

    marcaSelect.addEventListener('change', async (e) => {
      const marca = e.target.value;

      if (!marca) {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Seleccione primero una marca...</option>';
        return;
      }

      try {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Cargando modelos...</option>';

        const response = await modeloService.obtenerPorMarca(marca);
        const modelos = response.data.modelos || [];

        modeloSelect.innerHTML = `
          <option value="">Seleccione un modelo...</option>
          ${modelos.map(modelo => `
            <option value="${modelo.nombre}">
              ${modelo.codigo} - ${modelo.nombre}${modelo.linea ? ` · ${modelo.linea}` : ''}
            </option>
          `).join('')}
        `;

        modeloSelect.disabled = false;
      } catch (error) {
        console.error('Error al cargar modelos:', error);
        modeloSelect.innerHTML = '<option value="">Error al cargar modelos</option>';
        toast.error('No se pudieron cargar los modelos');
      }
    });
  },

  setupCascadaEdit() {
    const marcaSelect = document.getElementById('marca-edit-select');
    const modeloSelect = document.getElementById('modelo-edit-select');

    if (!marcaSelect || !modeloSelect) return;

    marcaSelect.addEventListener('change', async (e) => {
      const marca = e.target.value;

      if (!marca) {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Seleccione primero una marca...</option>';
        return;
      }

      try {
        modeloSelect.disabled = true;
        modeloSelect.innerHTML = '<option value="">Cargando modelos...</option>';

        const response = await modeloService.obtenerPorMarca(marca);
        const modelos = response.data.modelos || [];

        modeloSelect.innerHTML = `
          <option value="">Seleccione un modelo...</option>
          ${modelos.map(modelo => `
            <option value="${modelo.nombre}">
              ${modelo.codigo} - ${modelo.nombre}${modelo.linea ? ` · ${modelo.linea}` : ''}
            </option>
          `).join('')}
        `;

        modeloSelect.disabled = false;
      } catch (error) {
        console.error('Error al cargar modelos:', error);
        modeloSelect.innerHTML = '<option value="">Error al cargar modelos</option>';
        toast.error('No se pudieron cargar los modelos');
      }
    });
  },

  async viewTractor(numSerie) {
    try {
      const tractor = await tractorService.getByNumSerie(numSerie);

      const tieneGps = !!tractor.gps_vehiculo_id;
      const gpsLine = tieneGps
        ? `<div><strong>GPS:</strong> ${tractor.gps_nombre_activo || '-'} ${tractor.gps_placa ? `(placa: ${tractor.gps_placa})` : ''}</div>`
        : `<div><strong>GPS:</strong> <span style="color: var(--text-muted);">Sin vincular</span></div>`;

      const content = `
        <div style="display: grid; gap: var(--spacing-md);">
          <div><strong>Número de Serie:</strong> ${tractor.num_serie}</div>
          <div><strong>Modelo:</strong> ${tractor.modelo}</div>
          <div><strong>Marca:</strong> ${tractor.marca}</div>
          <div><strong>Serie Motor:</strong> ${tractor.serie_motor || 'N/A'}</div>
          <div><strong>Almacén:</strong> ${tractor.almacen_nombre || 'Sin asignar'}</div>
          <div><strong>Horas Motor:</strong> ${Number(tractor.horas_motor) || 0} hrs</div>
          <div><strong>Estado:</strong>
            <span class="badge ${tractorService.getEstadoBadgeClass(tractor.estado)}">
              ${tractorService.formatEstado(tractor.estado)}
            </span>
          </div>
          <div><strong>Certificación OCIMA:</strong> ${tractor.tiene_certificacion_ocima ? 'Sí' : 'No'}</div>
          ${gpsLine}
        </div>
      `;

      const buttons = [];
      if (permisos.canView('tracking')) {
        buttons.push({
          text: 'Ver Tracking',
          class: 'btn-info',
          disabled: !tieneGps,
          title: tieneGps ? 'Abrir tracking de este tractor' : 'Este tractor no tiene GPS vinculado',
          closeOnClick: tieneGps,
          onClick: () => {
            if (!tieneGps) return;
            router.navigate(`/admin/tracking/${tractor.gps_vehiculo_id}`);
          }
        });
      }
      buttons.push({ text: 'Cerrar', class: 'btn-secondary' });

      modal.open('Detalle del Tractor', content, buttons);
    } catch (error) {
      toast.error('Error al cargar tractor');
    }
  },

  async editTractor(numSerie) {
    try {
      const tractor = await tractorService.getByNumSerie(numSerie);

      // Cargar marcas
      const marcasResponse = await modeloService.obtenerMarcas();
      const marcas = marcasResponse.data.marcas || [];

      // Cargar modelos de la marca actual
      const modelosResponse = await modeloService.obtenerPorMarca(tractor.marca);
      const modelos = modelosResponse.data.modelos || [];

      // Si el tractor viene de una OC, el NS, marca y modelo son la spec
      // del proveedor y no se editan desde aquí. Se cambian desde el detalle
      // de la OC (Corregir NS / Liberar NS).
      const vieneDeOC = !!tractor.oc_folio;
      const disabledAttr = vieneDeOC ? 'disabled' : '';
      const disabledStyle = vieneDeOC ? 'opacity: 0.6; cursor: not-allowed;' : '';

      const ocBanner = vieneDeOC ? `
        <div style="display: flex; gap: 0.6rem; align-items: center; padding: 0.6rem 0.9rem; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 6px; margin-bottom: 1rem; color: #1e40af; font-size: 0.875rem;">
          <span style="font-size: 1rem; line-height: 1.2;">ℹ️</span>
          <div style="flex: 1; min-width: 0;">
            Definido por la <strong>${tractor.oc_folio}</strong>.
          </div>
        </div>
      ` : '';

      const formHtml = `
        ${ocBanner}
        <div class="form-group">
          <label class="form-label">Número de Serie</label>
          <input type="text" class="form-input" value="${tractor.num_serie}" disabled />
          ${vieneDeOC ? '' : `
            <small style="color: var(--text-muted); font-size: 0.85rem;">
              El número de serie no puede modificarse
            </small>
          `}
        </div>

        <div class="form-group">
          <label class="form-label">Marca *</label>
          <select name="marca" id="marca-edit-select" class="form-select" required ${disabledAttr} style="${disabledStyle}">
            <option value="">Seleccionar marca...</option>
            ${marcas.map(marca => `
              <option value="${marca}" ${marca === tractor.marca ? 'selected' : ''}>${marca}</option>
            `).join('')}
          </select>
          ${vieneDeOC ? '' : `
            <small style="color: var(--text-muted); font-size: 0.85rem;">
              Cambiar la marca recargará los modelos disponibles
            </small>
          `}
        </div>

        <div class="form-group">
          <label class="form-label">Modelo *</label>
          <select name="modelo" id="modelo-edit-select" class="form-select" required ${disabledAttr} style="${disabledStyle}">
            <option value="">Seleccione un modelo...</option>
            ${modelos.map(modelo => `
              <option value="${modelo.nombre}" ${modelo.nombre === tractor.modelo ? 'selected' : ''}>
                ${modelo.codigo} - ${modelo.nombre}${modelo.linea ? ` · ${modelo.linea}` : ''}
              </option>
            `).join('')}
          </select>
          ${vieneDeOC ? '' : `
            <small style="color: var(--text-muted); font-size: 0.85rem;">
              Los modelos se filtran según la marca
            </small>
          `}
        </div>

        <div class="form-group">
          <label class="form-label">Serie del Motor</label>
          <input type="text" name="serie_motor" class="form-input" value="${tractor.serie_motor || ''}" />
        </div>

        <div class="form-group">
          <label class="form-label">Almacén</label>
          <select name="almacen_id" class="form-select">
            <option value="">Sin asignar</option>
            ${(this.almacenes || []).map(a => `
              <option value="${a.id}" ${String(a.id) === String(tractor.almacen_id) ? 'selected' : ''}>
                ${a.codigo} - ${a.nombre}${a.ubicacion ? ` (${a.ubicacion})` : ''}
              </option>
            `).join('')}
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Horas del Motor</label>
          <input type="number" name="horas_motor" class="form-input" value="${Number(tractor.horas_motor) || 0}" min="0" step="0.01" />
        </div>

        <div class="form-group">
          <label class="form-label">Estado</label>
          <select name="estado" class="form-select">
            ${tractorService.getEstados().map(e =>
              `<option value="${e.value}" ${e.value === tractor.estado ? 'selected' : ''}>${e.label}</option>`
            ).join('')}
          </select>
        </div>

        <div class="form-group">
          <label style="display: flex; align-items: center; gap: 0.5rem;">
            <input type="checkbox" name="tiene_certificacion_ocima" ${tractor.tiene_certificacion_ocima ? 'checked' : ''} />
            <span>Tiene Certificación OCIMA</span>
          </label>
        </div>
      `;

      modal.form('Editar Tractor', formHtml, async (data) => {
        try {
          data.almacen_id = data.almacen_id ? parseInt(data.almacen_id, 10) : null;
          if (data.horas_motor !== undefined) {
            data.horas_motor = data.horas_motor === '' || data.horas_motor == null ? 0 : parseFloat(data.horas_motor);
          }
          await tractorService.update(numSerie, data);
          toast.success('Tractor actualizado exitosamente');
          modal.close();
          this.loadTractores();
        } catch (error) {
          toast.error(error.message || 'Error al actualizar tractor');
        }
      });

      // Configurar cascada Marca → Modelo después de que el modal se renderice
      setTimeout(() => {
        this.setupCascadaEdit();
        // Normalizar serie de motor (NS está disabled en este form, no requiere normalizer).
        const motorInput = document.querySelector('input[name="serie_motor"]');
        if (motorInput) attachNormalizer(motorInput, normalizers.alfanumUpper);
      }, 100);

    } catch (error) {
      console.error('Error al cargar tractor:', error);
      toast.error('Error al cargar tractor');
    }
  },

  toggleRow(numSerie) {
    const detailRow = document.getElementById(`detail-${numSerie}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  deleteTractor(numSerie, tieneRecepciones = false, ocFolio = '') {
    // El check de OC va primero: si el tractor viene de OC, ese es el motivo
    // raíz (la recepción es una consecuencia) y el camino correcto es Liberar NS.
    if (ocFolio) {
      modal.alert(
        'No se puede eliminar',
        `El tractor <strong>${numSerie}</strong> proviene de la <strong>${ocFolio}</strong>.`
      );
      return;
    }
    if (tieneRecepciones) {
      modal.alert(
        'No se puede eliminar',
        `El tractor <strong>${numSerie}</strong> tiene recepciones asociadas.`
      );
      return;
    }
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar el tractor <strong>${numSerie}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await tractorService.delete(numSerie);
          toast.success('Tractor eliminado exitosamente');
          this.loadTractores();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar tractor');
        }
      }
    );
  }
};
